<template>
  <div class="v-icon mr-2 ">
    <v-dialog
      :value="editEcsCompanyDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <DialogTitle
          :close="closeEditItem"
          :dialog-name="dialogName"
        />
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  counter
                  label="Name"

                  maxlength="90"
                  v-model="editName"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Address Line One"
                  v-model="editAddressLineOne"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Address Line Two"
                  v-model="editAddressLineTwo"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Town"
                  v-model="editTown"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Postcode"
                  v-model="editPostCode"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="County"
                  v-model="editCounty"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-autocomplete
                  :items="personnelCountryList"
                  item-text="name"
                  item-value="name"
                  label="Country"
                  v-model="editCountry"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Fax Number"
                  v-model="editFaxNumber"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Website Address"
                  v-model="editWebsiteAddress"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Telephone Number"
                  v-model="editTelephoneNumber"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Registration Number"
                  v-model="editRegistrationNumber"
                />
              </v-flex>
              <v-flex
                  md12
                  sm12
                  xs12
              >
                  <v-select
                      :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                      item-text="name"
                      item-value="Id"
                      label="Is Limited Company"
                      v-model="editIsLimitedCompany"
                  />
              </v-flex>
              <v-flex
                  md12
                  sm12
                  xs12
              >
                  <v-select
                      :items="[{Id: true, name: 'Live'}, {Id: false, name: 'Not Live'}]"
                      item-text="name"
                      item-value="Id"
                      label="Is Live"
                      v-model="editIsActive"
                  />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <DialogActions
          :close="closeEditItem"
          :save="saveEditItemAndCloseDialog"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '@/components/editTableFunctions';

    import {LOAD_ECS_COMPANY_TO_EDIT, RESET_DEFAULT_ECS_COMPANY_TO_EDIT, TOGGLE_EDIT_ECS_COMPANY_DIALOG, UPDATE_ECS_COMPANY_FIELD} from "@/store/ecs_company/mutations";
    import {FETCH_ECS_COMPANY_LIST, SAVE_EDITED_ECS_COMPANY} from "@/store/ecs_company/actions.js";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js"
    import DialogTitle from "../../../components/DialogTitle";
    import DialogActions from "../../../components/DialogActions";

    export default {
        name: "EditEcsCompanyDialog",

        validations: {
            // editAddressLineOne: { required },
            // editPostCode: { required },
            // editEmailAddressPersonal: { email },
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],


        props: {
            // item: {
            //     type: Object,
            //     required: true,
            // },
        },
        data() {
            return {
                // Required for editTableFunctions
                dialogName: 'Edit ECS Company',
                startDateMenu: false,
                endDateMenu: false,
            }
        },
        computed: {
            editEcsCompanyDialog: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompanyDialog;
                },
            },
            editName: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.name;
                },
                set(value) {
                    this.updateEditedValue('name', value);
                },
            },
            editAddressLineOne: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.addressLineOne;
                },
                set(value) {
                    this.updateEditedValue('addressLineOne', value);
                },
            },
            editAddressLineTwo: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.addAddressLineTwo;
                },
                set(value) {
                    this.updateEditedValue('addressLineTwo', value);
                },
            },
            editTown: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.town;
                },
                set(value) {
                    this.updateEditedValue('town', value);
                },
            },
            editCounty: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.county;
                },
                set(value) {
                    this.updateEditedValue('county', value);
                },
            },
            editCountry: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.country;
                },
                set(value) {
                    this.updateEditedValue('country', value);
                },
            },
            editPostCode: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.postCode;
                },
                set(value) {
                    this.updateEditedValue('postCode', value);
                },
            },
            editWebsiteAddress: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.websiteAddress;
                },
                set(value) {
                    this.updateEditedValue('websiteAddress', value);
                },
            },
            editFaxNumber: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.faxNumber;
                },
                set(value) {
                    this.updateEditedValue('faxNumber', value);
                },
            },
            editTelephoneNumber: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.telephoneNumber;
                },
                set(value) {
                    this.updateEditedValue('telephoneNumber', value);
                },
            },
            editRegistrationNumber: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.registrationNumber;
                },
                set(value) {
                    this.updateEditedValue('registrationNumber', value);
                },
            },
            editIsLimitedCompany: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.isLimitedCompany;
                },
                set(value) {
                    this.updateEditedValue('isLimitedCompany', value);
                },
            },
            editIsActive: {
                get() {
                    return this.$store.state.ecsCompany.editEcsCompany.isActive;
                },
                set(value) {
                    this.updateEditedValue('isActive', value);
                },
            },
            ...mapGetters(
            [
                "personnelCountryList"
            ]
            ),
            ...mapGetters({
                id: "editTeamId"
            })
        },

        mounted() {
            this.fetchEcsCompanyList();
        },

        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            fetchEcsCompanyList() {
                this.$store.dispatch(FETCH_ECS_COMPANY_LIST);
            },
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_ECS_COMPANY_LIST,
                updateTableItemRecord: SAVE_EDITED_ECS_COMPANY,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_ECS_COMPANY_DIALOG,
                loadTableItemToEdit: LOAD_ECS_COMPANY_TO_EDIT,
                updateTableItemToEdit: UPDATE_ECS_COMPANY_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_ECS_COMPANY_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
